var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_312_74507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#666666"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_312_74507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93836 3.49677V14.7628C5.54877 13.8189 2.88959 13.8189 0.5 14.7628V3.49677C0.5 3.46125 0.516108 3.44105 0.530512 3.43201C0.860674 3.22478 1.47442 2.86099 2.1717 2.55058C2.8813 2.23468 3.62107 2 4.21918 2C4.81729 2 5.55707 2.23468 6.26666 2.55058C6.96395 2.86099 7.57769 3.22478 7.90785 3.43201C7.92226 3.44105 7.93836 3.46125 7.93836 3.49677ZM7.93837 14.7905C7.93837 14.7905 7.93836 14.7905 7.93836 14.7905L7.93837 14.7905Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 3.49677V14.7628C13.1105 13.8189 10.4514 13.8189 8.06177 14.7628V3.49677C8.06177 3.46125 8.07788 3.44105 8.09228 3.43201C8.42244 3.22478 9.03619 2.86099 9.73347 2.55058C10.4431 2.23468 11.1828 2 11.781 2C12.3791 2 13.1188 2.23468 13.8284 2.55058C14.5257 2.86099 15.1395 3.22478 15.4696 3.43201C15.484 3.44105 15.5001 3.46125 15.5001 3.49677ZM15.5001 14.7905C15.5001 14.7905 15.5001 14.7905 15.5001 14.7905L15.5001 14.7905Z",
    stroke: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeIcon);
export default __webpack_public_path__ + "static/media/knowledge-icon.c7a7ebf1f237f586bcde2bc555804bd9.svg";
export { ForwardRef as ReactComponent };